import { MouseEventHandler } from 'react';
import { Badge } from 'design-system/react';

import { useAppNavigate, useRequireFeatureFlagIfProvided } from '../../hooks';

interface Props {
  featureId: string;
}

export function FeatureBadge({ featureId }: Props) {
  const shouldShow = useRequireFeatureFlagIfProvided('show_feature_badge');
  const navigate = useAppNavigate();

  if (!shouldShow) {
    return null;
  }

  const handleClick: MouseEventHandler = (event) => {
    event.stopPropagation();
    navigate.toFeatureById(featureId);
  };

  return (
    <Badge
      variant="primary"
      onClick={handleClick}
      className="cursor-pointer transition-colors hover:bg-bg-accent-muted"
    >
      {featureId}
    </Badge>
  );
}
